
App.directive('appFilelist', function(){
    'use strict';
  
    return {
        templateUrl: '/app/views/partials/filelist.html',
        restrict: 'E',
        replace: true,
        scope: {
            selectorOptions: '=',
            files: '=',
            zip: '=', // type, name, field, entityId, extension
            webdavFiles: '=',
            sync: '=' //project, field
        }
    };
  
  });